export const Header = () => {
    const onLink = (action) => {
        let element;
        switch (action) {
            case "how":
                element = document.querySelector('.about');
                element.scrollIntoView({behavior: "smooth", block: "center", inline: "start"});
                break;
            case "start":
                element = document.querySelector('.sounds');
                element.scrollIntoView({behavior: "smooth", block: "center", inline: "start"});
                break;
        }
    }

    return (
        <header className="header">
            <div className="menu">
                <div className="title">
                    <h2>WkSounds</h2>
                </div>
                <div className="list">
                    <div className="list-item" onClick={() => onLink("how")}>
                        <span>Як це працює</span>
                    </div>
                    <div className="list-item" onClick={() => onLink("start")}>
                        <span>Почати</span>
                    </div>
                </div>
            </div>
            <div className="header-content">
                <div className="descr">Ваш безкоштовний сервіс для відпочинку та роботи з великою кількістю звуків. Змішуйте різні навколишні шуми та створюйте ідеальний звуковий ландшафт для роботи та відпочинку</div>
                <button className="header-btn" onClick={() => onLink("start")}>Почати</button>
            </div>
        </header>
    );
}